import Voting from './Voting'
export * from './types'
export default Voting
